import React, { useEffect } from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';

import { GoBackArrowBtn } from '@/components/GoBackArrowBtn/GoBackArrowBtn';
import { Loader } from '@/components/Loader/loader';
import { useAuth } from '@/hooks/useAuth';
import { useMentionMe } from '@/hooks/useMentionMe';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

export const Sponsorship: React.FC = () => {
  const { windowWidth } = useScreenSize();
  const { user } = useAuth();
  const { isScriptLoaded, isAdblockDetected, hasEmail } = useMentionMe();

  if (sessionStorage.parcoursVersementData) {
    sessionStorage.removeItem('parcoursVersementData');
  }

  useEffect(() => {
    TRACKING_INSTANCE.setTcVars({
      page_nom: 'parrainage',
      page_template: 'espace client',
      user_id: user?.id,
      user_client: user?.type === 'Client',
      user_connexion: user?.success,
      user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
    });
    void TRACKING_INSTANCE.triggerEvent('page', undefined, {
      event_id: 'page',
      event_categorie: 'affichage espace client',
      event_nom: 'parrainage',
      event_page: 'parrainage',
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [user]);

  return (
    <div className={styles.sponsorshipContent}>
      {!isScriptLoaded && <Loader />}
      <MtxGrid row className={styles.sponsorshipContentHead}>
        {windowWidth < 900 && <GoBackArrowBtn />}
        <MtxGrid col={12} offset={0}>
          <h1>Parrainez vos proches</h1>
        </MtxGrid>
      </MtxGrid>
      {(isAdblockDetected || !hasEmail) && (
        <div className={styles.adblockWarning}>
          <p>
            <strong>
              {isAdblockDetected ? '⚠️ Bloqueur de publicité détecté' : "⚠️ L'utilisateur ne possède pas d'email"}
            </strong>
          </p>
          <p>
            Pour accéder au programme de parrainage,{' '}
            {isAdblockDetected
              ? 'veuillez désactiver votre bloqueur de publicité sur cette page.'
              : 'veuillez contacter le support.'}
          </p>
        </div>
      )}
      <div id="mmWrapper"></div>
    </div>
  );
};
